import {Component} from "@angular/core";
import {ICellRendererParams} from "ag-grid-community";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {DxCoreUtils} from "../../../../../dx-core/utiles/dx-core-utils";
import {DxGridColumnDataType} from "../../../../domain/ui-options/column/dx-grid-column-data-type";
import {DxBaseCellRenderComponent} from "../dx-base-cell-render.component";


/**
 * Рендер для ячеек, являющихся гиперссылками.
 * То есть текст в ячейке отображается в формате гиперссылки, а по клику на него идет переход.
 * Например, открывается карточка объекта.
 */
@Component({
  selector: 'dx-link-cell-render',
  templateUrl: './dx-link-cell-render.component.html',
  styleUrls: ['./dx-link-cell-render.component.css']
})
export class DxLinkCellRenderComponent extends DxBaseCellRenderComponent {
  /**
   * Паттерн регулярного выражения для проверки начинается ли эндпоин с http/https.
   * @name PROTOCOL_PATTERN
   * @type {string}
   * @defaultValue - `'^(http://|https://)'`
   */
  private static PROTOCOL_PATTERN: string = '^(http://|https://)';

  constructor(private _router: Router,
              private _location: Location) {
    super();
  }


  protected _init(params: ICellRendererParams): void {
    super._init(params);
    this.value = this.transform(this._params.value);
  }


  get dataTypeOptions(): DxGridColumnDataType {
    return this._dataTypeOptions;
  }


  public onLinkClick(): void {
    let url = this._prepareLinkUrl();
    if (url) {
      if (this._dataTypeOptions.newWindow) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    }
  }


  private _prepareLinkUrl(): string {
    let url: string;
    const regExp: RegExp = new RegExp(DxLinkCellRenderComponent.PROTOCOL_PATTERN, 'i');
    if(!regExp.test(this._dataTypeOptions.linkPattern)) {
      // TODO: По возможности убрать ссылку на глобальный объект window
      // TODO: и предоставить его через механизм DI
      const hostPort: string = window.location.origin;
      const baseHref: string = window.location.pathname;
      url = hostPort;
      url += baseHref ? baseHref : '/';
      url += this._location.prepareExternalUrl(this._dataTypeOptions.linkPattern);
    }

    // Заполняем параметры в паттерне url, если таковые имеются
    if(this._dataTypeOptions.linkParams && this._dataTypeOptions.linkParams.length > 0) {
      let propValue: string;
      let propValueGetter: any;

      this._dataTypeOptions.linkParams.forEach(param => {
        // Получаем значение проперти
        propValueGetter = DxCoreUtils.getterForProp(param);
        propValue = '' + propValueGetter(this._row, param);
        url = url.replace('${' + param + '}', propValue);
      });
    }
    return url;
  }
}
